import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCommon } from "@obg/common.config";
import { CORE_ROUTE } from "@obg/ngx.core";
import { ConfigService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class AlternativeMainPageConfig {
	constructor(private service: ConfigService<ObgConfigFeAdaptiveClientCommon>) {}

	getAlternativeMainPageEnabled(): boolean {
		return this.service.get((config) => config.common.alternativeMainPage.isEnabled, false);
	}

	getAlternativeMainPagePath(): string {
		return this.service.get((config) => config.common.alternativeMainPage.path, CORE_ROUTE.home);
	}

	getSupportedMarkets(): string[] {
		return this.service.get((config) => config.common.alternativeMainPage.supportedMarkets, []);
	}
}
